/* Form verifier */
window.contact_verify = function(name, val) {
    if (name === 'telefon') {
        return true;
        // return !(val.length && val.length < 9);
    }

    let regex;
    switch(name) {
        // case 'telefon': regex = /^(\+420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/; break;
        case 'telefon': regex = /^(\+420)?[0-9 \-]+$/; break;
        case 'email': regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; break;
        default : regex = 'skip'; break;
    }

    // console.log('contact_verify', name, val, regex);

    if(regex == 'skip') {
        if(val.length > 0) {
            return true;
        }
    } else if (regex.test(String(val).toLowerCase())) {
        return true;
    // } else if(name == 'telefon' && val.length == 0) {
    //     return true;
    }
    return false;
}

/* Verify all form's inputs */
window.verifyEverything = function() {
    let allgood = true;
    $.each($('form').serializeArray(), function() {
        if(!contact_verify(this.name, this.value)) {
            if(this.value.length > 0) {
                allgood = false;
            } else {
                allgood = false;
            }
        }
    });
    return allgood;
}

/* Function to change state of button */
window.change_button = function(formEl) {
    var buttonEl = formEl.find('button');
    if(verifyEverything()) {
        buttonEl.removeClass('cta-inactive');
    } else {
        buttonEl.addClass('cta-inactive');
    }
}

/* Main contact function
 * Saves into database, session
 * redirects to another page
*/
window.contact_with_redirect = function(isHomepage) {
    if(verifyEverything()) {
        var result_array = { };
        $.each($('form').serializeArray(), function() {
            result_array[this.name] = this.value;
        });

        session_ajax(result_array,
            function(data) {
                console.log('data', data);

                data = JSON.parse(data);
                var timeStamp = Math.floor(Date.now());
                var args = {
                    'jmeno': data['jmeno'],
                    'prijmeni': data['prijmeni'],
                    'telefon': data['telefon'],
                    'email': data['email'],
                    'token': returnToken(data['jmeno']+data['prijmeni']+data['email']+timeStamp),
                    'utm_source': data['utm_source'],
                }
                do_ajax('new_user', args,
                function(data) {
                    console.log('new_user', data);
                    let arrargs = {};
                    arrargs['user_id'] = data;
                    session_ajax(arrargs, function() {
                        href = '';
                        // TODO: create global function for redirecting, which would include lang in the URL.
                        href = (isHomepage) ? 'formular.php' : 'index.php';

                        window.redirectWithLogging(href);
                    });
                });
            }
        );
   }
}

$(document).ready(function() {
    $('input').keyup(function() {
        var inputName = $(this).attr('name');

        // if (inputName === 'telefon') {
        //     return;
        // }

        var inputValue = $(this).val();
        var formParent = $(this).parents('.form');
        change_button(formParent);

        if(contact_verify(inputName, inputValue)) {
            if(inputValue.length > 0) {
                $(this).parent().removeClass('input-wrong');
                $(this).parent().addClass('input-ok');
            } else {
                $(this).parent().removeClass('input-ok');
                $(this).parent().addClass('input-wrong');
            }
        } else {
            if(inputValue.length > 0) {
                $(this).parent().removeClass('input-ok input-wrong');
            } else {
                $(this).parent().removeClass('input-ok input-wrong');
            }
        }
    });

    $('input').on('focusout', function() {
        var inputName = $(this).attr('name');

        if (inputName === 'telefon') {
            return;
        }

        var inputValue = $(this).val();
        var formParent = $(this).parents('.form');
        change_button(formParent);

        if(contact_verify(inputName, inputValue)) {
            if(inputValue.length > 0) {
                $(this).parent().removeClass('input-wrong');
                $(this).parent().addClass('input-ok');
            } else {
                if(inputName != "telefon") {
                    $(this).parent().removeClass('input-ok');
                    $(this).parent().addClass('input-wrong');
                }
            }
        } else {
            if(inputValue.length > 0) {
                $(this).parent().removeClass('input-ok');
                $(this).parent().addClass('input-wrong');
            } else {
                if(inputName != "telefon") {
                    $(this).parent().removeClass('input-ok');
                    $(this).parent().addClass('input-wrong');
                }
            }
        }
    });

    setInterval(() => {
        $('.form').each(function() {
            change_button($(this));
            $('input').each(function() {
                var inputName = $(this).attr('name');
                var inputValue = $(this).val();
                if(contact_verify(inputName, inputValue)) {
                    if(inputValue.length > 0) {
                        $(this).parent().removeClass('input-wrong');
                        $(this).parent().addClass('input-ok');
                    } else {
                        $(this).parent().removeClass('input-ok');
                    }
                } else {
                    if(inputValue.length > 0) {
                        $(this).parent().removeClass('input-ok');
                        $(this).parent().addClass('input-wrong');
                    } else {
                        $(this).parent().removeClass('input-ok');
                    }
                }
            })
        });
    }, 1000);
});
